<template>
  <div class="flex flex-col mb-4 pt-4">
    <div class="text-2xl my-4 font-bold">
      {{ LL.suggest_question() }}
    </div>
    <CommonLoadingCard v-if="isLoading" />
    <LazyEmpty v-else-if="!questions.length" />
    <div v-else class="grid grid-cols-1 md:grid-cols-3 gap-3">
      <InterviewQuestionSuggest
        v-for="question in questions"
        :key="question?.slug"
        :question="question"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { TSuggestQuestion, TSuggestQuestionResponse } from "~/features/post";
import { typesafeI18n } from "~/locales/i18n-vue";
const { params } = useRoute();
const config = useRuntimeConfig();

const { LL } = typesafeI18n();

const questions = ref<TSuggestQuestion[]>([]);
const isLoading = ref<boolean>(false);

onMounted(async () => {
  try {
    isLoading.value = true;
    const result: TSuggestQuestionResponse = await $fetch(
      `${config.public.apiBase}/api/posts/suggest-question/${params.slug}?limit=4`
    );
    questions.value = result.data;
  } catch (e) {
    console.error(e);
    questions.value = [];
  } finally {
    isLoading.value = false;
  }
});
</script>
